// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

var BulkCancelContractsController = function ($scope, $http, $location, BulkUpdateContractsFilterBag, gettext, gettextCatalog,
    BulkUpdatesNavigationHelper, DocumentTemplate, ProductInfo) {

    /* Translations */
    $scope.previewTabHeading = gettext('Create preview');
    $scope.executeTabHeading = gettext('Execute');
    $scope.dunningLevelTooltip = gettext('Please keep in mind that a particular dunning level may mean something different in contracts that use an outdated escalation process.');

    $scope.previewExecuteButtonTooltip_OperationInProgress = gettext('Only one bulk update operation can be in progress at the same time');
    $scope.previewButtonTooltip_FileFilterRequired = gettext('Please choose a file to create a preview');
    $scope.previewButtonTooltip_StatusFilterRequired = gettext('Please choose a status to create a preview');
    $scope.previewButtonTooltip_FilterInvalid = gettext('Please select at least one filter to create a preview');
    $scope.previewButtonTooltip_EndDateRequired = gettext('Please choose a contract end date to create a preview');

    /* Filter & Preview */
    $scope.flagToSwitchToExecuteTab = true;
    $scope.ResetFileFlag = false;

    // Creating this object because of https://www.youtube.com/watch?v=DTx23w4z6Kc&ab_channel=JohnLindquist
    // (or https://github.com/angular/angular.js/wiki/Understanding-Scopes)
    // Otherwise e.g. isPreviewDisabled() couldn't get a fresh BookingDate value; since booking date
    // datepicker is placed inside the tab set, it's being accessed inside the child scope
    $scope.scopeHolder = {
        Filter: BulkUpdateContractsFilterBag.filter ? BulkUpdateContractsFilterBag.filter : emptyFilter(),
        Parameters: {},
        ShowOutdatedPreviews: false,
        Tab: "preview",
        IsLoading: false,
        BookingDateConstraints: {},
        PaymentEscalations: ["All", "On", "Off"],
        IsAnyOperationInProgress: false,
    };
    
    // allows to refresh the list of bulk operation from the controller 
    $scope.refreshHandler = { refresh: null };
    function refreshBulkOperations() {
        if ($scope.refreshHandler.refresh)
            $scope.refreshHandler.refresh();
    }
    
    $scope.templates = DocumentTemplate.query({ documentType: "Dunning" });
    getContractStatuses();
    $scope.productInfo = ProductInfo.get();
    
    // navigate to execution tab when the page is opened and some operation is in progress
    $scope.$watch("scopeHolder.IsAnyOperationInProgress", function(hasOperationsInProgress) {
       if ($scope.flagToSwitchToExecuteTab && hasOperationsInProgress) {
           $scope.flagToSwitchToExecuteTab = false;
           $scope.scopeHolder.Tab = "execute";
       }
    });

    /* scope functions */
    $scope.filterByIdChanged = function () {
        $scope.filterByIds = $scope.scopeHolder.Filter.FilterByIdType !== 'None';
        if ($scope.filterByIds) {
            $scope.scopeHolder.Filter.Status = "";
            $scope.scopeHolder.Filter.DunningLevel = "";
            $scope.scopeHolder.Filter.PaymentEscalation = "";
        }
    }

    $scope.saveFile = function ($files) {
        $scope.scopeHolder.Filter.File = $files[0];
        if ($scope.scopeHolder.Filter.File)
            $scope.isFileSelected = true;
        else
            $scope.isFileSelected = false;
        $scope.$apply();
    };

    $scope.isPreviewDisabled = function () {
        return !!$scope.getValidationError();
    };

    $scope.getValidationError = function () {
        if ($scope.scopeHolder.Filter.FilterByIdType !== 'None') {
            if (!$scope.scopeHolder.Filter.File)
                return $scope.previewButtonTooltip_FileFilterRequired;
        }
        else {
            // status filter is required
            if (!$scope.scopeHolder.Filter.Status)
                return $scope.previewButtonTooltip_StatusFilterRequired;
            // at least one filter should be not "All"
            else if ($scope.scopeHolder.Filter.Status === 'All' &&
                !$scope.scopeHolder.Filter.DunningLevel &&
                $scope.scopeHolder.Filter.PaymentEscalation === '')
                return $scope.previewButtonTooltip_FilterInvalid;
        }

        // end date is required
        if (!$scope.scopeHolder.Parameters.ChangeDate && !$scope.scopeHolder.Parameters.PresetChangeDate)
            return $scope.previewButtonTooltip_EndDateRequired;
        // there should be no running operation
        else if ($scope.scopeHolder.IsAnyOperationInProgress)
            return $scope.previewExecuteButtonTooltip_OperationInProgress;

        return null;
    };

    $scope.createPreview = function () {
        var formData = new FormData();
        formData.append("Type", "0");
        formData.append("Filter.IdType", $scope.scopeHolder.Filter.FilterByIdType);

        if ($scope.filterByIds) {
            formData.append("Filter.IdsFile", $scope.scopeHolder.Filter.File);
        }
        else {
            formData.append("Filter.CancelContracts.Status", getFilterStatus($scope.scopeHolder.Filter.Status));
            if (!$scope.scopeHolder.Filter.DunningLevel)
                $scope.scopeHolder.Filter.DunningLevel = "";
            formData.append("Filter.CancelContracts.DunningTemplateId", $scope.scopeHolder.Filter.DunningLevel);
            formData.append("Filter.CancelContracts.PaymentEscalation", $scope.scopeHolder.Filter.PaymentEscalation);
        }

        let formattedBookingDate = moment($scope.scopeHolder.Parameters.ChangeDate).format();
        formData.append("Parameters.CancelContracts.ChangeDate", formattedBookingDate);
        formData.append("Parameters.CancelContracts.PresetChangeDate", $scope.scopeHolder.Parameters.PresetChangeDate === '' ? null : $scope.scopeHolder.Parameters.PresetChangeDate);

        $http({
            method: "POST",
            url: "/api/v1/bulkoperation/preview",
            data: formData,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            function () {
                refreshBulkOperations()
                $scope.scopeHolder.Tab = "execute";
                resetUploadedFile();
            }
        );
    };

    $scope.isExecutionDisabled = function () {
        return $scope.scopeHolder.IsAnyOperationInProgress;
    }

    $scope.execute = function (bulkUpdateId) {
        $http({
            method: "POST",
            url: "/api/v1/bulkOperation/" + bulkUpdateId + "/execute",
        }).then(
            function () {
                refreshBulkOperations();
                $scope.scopeHolder.Tab = "execute";
            }
        );
    }

    /* functions */
    function getContractStatuses() {
        $http({
            method: "GET",
            url: "/api/v1/bulkoperation/contractstatus"
        }).then(function (response) {
            $scope.scopeHolder.ContractStatuses = response.data;
        });
    }

    function getFilterStatus(status) {
        if (status === 'In Trial')
            return 'InTrial';

        return status;
    }
    
    function emptyFilter() {
        return {
            Action: "Cancel contracts",
            Status: "All",
            DunningLevel: null,
            PaymentEscalation: "",
            FilterByIdType: "None"
        };
    }

    var resetUploadedFile = function () {
        $scope.ResetFileFlag = !$scope.ResetFileFlag;
    };
};

BulkCancelContractsController.$inject = ["$scope", "$http", "$location", "BulkUpdateContractsFilterBag", "gettext", "gettextCatalog",
    "BulkUpdatesNavigationHelper", "DocumentTemplate", "ProductInfo"];
